module.exports = __webpack_public_path__ + "static/media/web-ats-04.f5e08ced.jpg";